import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_SDD_EvaluationOrder = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Syntax directed definition Evaluation Order"
    videos={[
      "https://www.youtube.com/embed/nIMBA0qO684",
      "https://www.youtube.com/embed/SxU6ypr6m78",
      "https://www.youtube.com/embed/c7F4NNih3i0",
      "https://www.youtube.com/embed/lz4HGafNSLA",
      "https://www.youtube.com/embed/HBxaCxgOWHg",
    ]}
    takeaways={[
      { text: "Practice different types of examples" },
      { text: "Theory questions are also possible from this topic" },
    ]}
    questions={[
      `1) Consider the following grammar for Boolean expressions and if-else statements. Write an SDD that evaluates arithmetic expressions (E, T, F). Evaluate Boolean expressions (B). Given the below input, construct the annotated parse tree showing how your SDD evaluates the Boolean expression and simulates the conditional assignment: if (3 +4) > 5 then assign x = 10 else assign x = 20

S -> if B then S1 else S2
S -> assign id = E
B -> E == E | E > E
E -> E + T | E - T | T
T -> T * F | T / F | F
F -> (E) | num`,

      `2) Apply the S-attributed definition and construct syntax trees for a simple expression grammar involving only the binary operators + and -. As usual, these operators are at the same precedence level and are jointly left associative. All variables/non-terminals have one synthesized attribute node, which represents a node of the syntax tree. E-> E1+T | E1-T | T, T->(E) | id | num`,

      `3) Construct the syntax tree for an expression a*4+c using SDD.`,

      `4) Draw an annotated parse tree for 4*5*(3+6)n and evaluate it using the SDD.`,

      `5) Explain the concept of Syntax Directed Definition (SDD) and discuss the two types of attributes used in SDD. How do dependency graphs help in determining the evaluation order for attribute computation? Provide an example illustrating the evaluation order using a simple expression grammar.`,

      `6) The following grammar generates expressions formed by applying an arithmetic operator + to integer and real constants. When two integers are added, the resulting type is an integer, otherwise, it is real.
i. Give a syntax-directed definition to determine the type of each sub-expression.
ii. Extend the syntax-directed definition of (a) to translate expressions into postfix notation as well as determining types. Use the unary operator 'inttoreal' to convert an integer value into an equivalent real value, so that both operands of + in the postfix form have the same type.

E->E+T|T
T->num.num|num`,

      `7) Construct a Syntax Tree for the given expression m=y+z-c/b*34, with the help of arithmetic expression grammar and semantic actions.`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_SDD_EvaluationOrder;
